export default __webpack_public_path__ + "static/media/apple.55bd6f8b.svg";